module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Door-open-1cdaf9c41fd516d7aaf73ff5766d3853.svg";